import iconSetFullScreenBlack from "../../assets/images/fullscreen-black.svg";
import screen from "../../assets/images/step-thumb-1.png";
import Player from "../../pages/fullscreen/player";

import LineProgressBar from "./LineProgressBar";

const StatusCaseComponentWrap = ({ children }) => <div className="m-t-64 flex-col align-items-center">{children}</div>;

const FakePlayerHead = ({ openFullscreen, isLeaving }) => (
  <>
    <img src={screen} width={362} height={202} className="br-556" alt="" />
    {!isLeaving && (
      <span className="flex relative p-lr-5 not-joined-fullscreen-button" id="go-to-fullscreen">
        <img src={iconSetFullScreenBlack} alt="fullscreen" className="btn-22 btn-fullscreen-mode" onClick={openFullscreen} />
        <div className="tooltip-type2"> Full Screen </div>
      </span>
    )}
  </>
);

const FakePlayerContent = ({ status, title, description, formattedDate, endTime, countdown, children }) => (
  <div className="m-t-32 flex-col align-items-center">
    {title && <div className="H2-SemiBold font-40">{title}</div>}
    {description && <div className="m-b-24 SH2-Light w-800 justify-content-center">{description}</div>}
    {status === "created" && (
      <>
        {formattedDate && (
          <div className="SH2-SemiBold fg-text-blue m-t-32">
            Scheduled for {formattedDate} to {endTime}
          </div>
        )}
        {countdown && <div className="B1-Medium"> {countdown}</div>}
      </>
    )}
    {children && children}
  </div>
);
export const MeetingLifecycleHandlers = () => {
  const NonJoinedLWProgressBar = ({ meeting, formattedDate, endTime, countdown, openFullscreen }) => {
    if (meeting.status) {
      return (
        <StatusCaseComponentWrap>
          <FakePlayerHead openFullscreen={openFullscreen} />
          <FakePlayerContent
            status={meeting.status}
            title={meeting.title}
            description={meeting.desc}
            formattedDate={formattedDate()}
            endTime={endTime()}
            countdown={countdown}>
            <div className="button button-lg button-r w-169 m-t-32 m-b-50">Cancel Meeting</div>
          </FakePlayerContent>
        </StatusCaseComponentWrap>
      );
    }
  };

  const CreatedStatus = ({ meeting, formattedDate, endTime, countdown, openFullscreen }) => (
    <NonJoinedLWProgressBar meeting={meeting} formattedDate={formattedDate} endTime={endTime} countdown={countdown} openFullscreen={openFullscreen} />
  );

  const StartErrorStatus = ({ meeting, openFullscreen }) => (
    <StatusCaseComponentWrap>
      <FakePlayerHead openFullscreen={openFullscreen} />
      <FakePlayerContent title={meeting.title} description={meeting.desc}>
        <p className="SH2-SemiBold">Error: Live Workspace has failed to start</p>
      </FakePlayerContent>
    </StatusCaseComponentWrap>
  );

  const pendingContent = (meeting, isUserMediaPermissions, isJoining) => {
    if (meeting?.status === "started") {
      if (!isUserMediaPermissions) return <p className="SH2-SemiBold">Preparing user media</p>;
      if (!isJoining) return <p className="SH2-SemiBold">Requesting meeting data</p>;
    }
    if (meeting?.status === "ending") {
      return <p className="SH2-SemiBold">Meeting is ending</p>;
    }
    return null;
  };

  const PendingStatus = ({ meeting, openFullscreen, isUserMediaPermissions, isJoining }) => (
    <StatusCaseComponentWrap>
      <FakePlayerHead openFullscreen={openFullscreen} />
      <FakePlayerContent title={meeting?.title} description={meeting?.desc}>
        {pendingContent(meeting, isUserMediaPermissions, isJoining)}
        <LineProgressBar infinite />
      </FakePlayerContent>
    </StatusCaseComponentWrap>
  );

  const StartedStatus = ({
    meeting,
    joinProgress,
    joinProgressLength,
    isJoining,
    isUserMediaPermissions,
    joinError,
    isJoined,
    openFullscreen,
    formattedDate,
    endTime,
    countdown,
    isLeaving,
    leaveProgress,
  }) => {
    if ((!isJoined && !isUserMediaPermissions) || (!isJoining && !isJoined)) {
      return PendingStatus({
        meeting,
        openFullscreen,
        isUserMediaPermissions,
        isJoining,
      });
    }

    if (joinError) {
      return (
        <StatusCaseComponentWrap>
          <FakePlayerHead openFullscreen={openFullscreen} />
          <FakePlayerContent title={meeting.title} description={meeting.desc}>
            <p className="SH2-SemiBold">Join Error: Failed to join</p>
          </FakePlayerContent>
        </StatusCaseComponentWrap>
      );
    }
    if (isJoining && !isJoined) {
      return (
        <StatusCaseComponentWrap>
          <FakePlayerHead openFullscreen={openFullscreen} />
          <FakePlayerContent
            status={meeting.status}
            title={meeting.title}
            description={meeting.desc}
            formattedDate={formattedDate()}
            endTime={endTime()}
            countdown={countdown}>
            {isUserMediaPermissions && (
              <>
                <div className="B1-Medium m-t-32">Join Progress - {Math.round((100 / joinProgressLength) * joinProgress)}%</div>
                <LineProgressBar progress={Math.round((100 / joinProgressLength) * joinProgress)} />
              </>
            )}
          </FakePlayerContent>
        </StatusCaseComponentWrap>
      );
    }

    if (isJoined) {
      if (isLeaving) {
        return (
          <StatusCaseComponentWrap>
            <FakePlayerHead openFullscreen={openFullscreen} isLeaving />
            <FakePlayerContent>
              <div className="B1-Medium m-t-32">Leave Progress - {Math.round((100 / 5) * leaveProgress)}%</div>
              <LineProgressBar progress={Math.round((100 / 5) * leaveProgress)} />
            </FakePlayerContent>
          </StatusCaseComponentWrap>
        );
      }
      return <Player openFullscreen={openFullscreen} />;
    }
  };

  const EndedStatus = ({ openFullscreen }) => <Player offlineVideo openFullscreen={openFullscreen} />;

  const DefaultStatusComponent = ({ meeting, openFullscreen, isUserMediaPermissions }) =>
    PendingStatus({
      meeting,
      openFullscreen,
      isUserMediaPermissions,
    });

  return {
    CreatedStatus,
    StartErrorStatus,
    PendingStatus,
    StartedStatus,
    EndedStatus,
    DefaultStatusComponent,
  };
};
